

export interface ILastSeenFilter {
  last_seen_gte?: string | undefined;
  last_seen_lte?: string | undefined;
}

export function instanceOfILastSeenFilter(object?: any): object is ILastSeenFilter {
  return !!object && ("last_seen_gte" in object || "last_seen_lte" in object);
}